import * as Yup from 'yup';

export const uploadFileValidationSchema = (isValid: boolean) => 
  Yup.object().shape({
    docs: Yup.array()
      .of(
        Yup.object().shape({
          stipTypeId: Yup.string().required('File type is required'),
        })
      )
      .required('Please upload at least one file'),
      assetId: Yup.string().nullable().when([], {
        is: () => isValid,
        then: Yup.string().required('Asset is required'),
        otherwise: Yup.string(),
      }),
  });

export const stipReviewValidationSchema = Yup.object().shape({
  reviewStatus: Yup.string().nullable().required('Review Status is required'),
  // reviewStatusNote: Yup.string().ensure().when('reviewStatus', {
  //   is:  'ApprovedCondition' || 'Denied',
  //   then: Yup.string().required("Please provide a note"),
  // }),
  reviewStatusNote: Yup.string()
    .ensure()
    .when('reviewStatus', {
      is: (reviewStatus: string) => {
        return reviewStatus === 'ApprovedCondition' || reviewStatus === 'Denied';
      },
      then: Yup.string().required('Please provide a note'),
    }),
});
